import { configureStore } from '@reduxjs/toolkit'
import UserSlice from './reduxSlice/UserSlice'

export default configureStore({
  reducer: {
      isLogin: UserSlice
  },
})